import 'animate.css'
import Swal from 'sweetalert2'
import { Constant } from '../constant'

export const AlertSatut = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  question: 'question',
  error: 'error',
}
export const AlertType = {
  toast: 'toast',
  normal: 'normal',
}

const animate = {
  showClass: {
    popup: `
      animate__animated
      animate__fadeInDown
      animate__delay-0.1s
    `,
  },
  hideClass: {
    popup: `
      animate__animated
      animate__fadeOutDown
      animate__faster
    `,
  },
}

const Toast = Swal.mixin({
  toast: true,
  showConfirmButton: false,
  position: 'top-right',
  // background: '#f27575de',
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer
    toast.onmouseleave = Swal.resumeTimer
  },
})

export const ToastAlert = (statut, message, time = null, title = '') => {
  return Toast.fire({
    icon: statut,
    title: title,
    timer: time ? time : 10000,
    text: message,
    position: 'top',
    showCloseButton: true,
  })
}

export const NormalAlert = async (statut, message, time = null, title = '') => {
  return Swal.fire({
    icon: statut,
    title: title,
    html: message,
    // confirmButtonColor: Constant.couleur.secondary,
    allowOutsideClick: false,
    showConfirmButton: true,
    confirmButtonColor: Constant.couleur.primary,
    cancelButtonColor: Constant.couleur.secondary,

    ...animate,
  }).then((result) => {
    if (result.isConfirmed && message === Constant.fr.JWT_EXPIRED || result.isConfirmed && message === Constant.fr.JWT_INVALID) {
      localStorage.clear()
      window.location.reload()
    }
  });
}
export const AlertMessage = async (type, statut, message, time = null) => {
  if (type === AlertType.toast) {
    return await ToastAlert(statut, message, time)
  } else {
    return await NormalAlert(statut, message)
  }
}

export function ConfirmAlert(msg, callbackFn){
  Swal.fire({
    title: "",
    text: msg,
    icon: "question",
    showCancelButton: true,
    allowOutsideClick: false,
    reverseButtons: true,
    confirmButtonColor: Constant.couleur.primary,
    // cancelButtonColor: "#d33",
    cancelButtonText: "Non!",
    confirmButtonText: "Oui, Confirmer!"
  }).then((result) => {
    if (result.isConfirmed) {
      callbackFn()
    }
  });
}
